// 📄 hooks/useCasosPruebaFallidos.ts
// Casos de prueba en estado "Fallido" de TODO el proyecto (cualquier
// solución/canal) — usado por la alerta de Cutover (ver cutover.tsx):
// antes de ir a producción conviene saber si queda algún escenario sin
// resolver, sin importar en qué canal haya fallado.
import { useEffect, useState } from 'react';
import { getCasosPrueba, CasoPrueba } from '../services/casoPruebaService.ts';

export function useCasosPruebaFallidos(projectId: string) {
  const [loading, setLoading] = useState(true);
  const [fallidos, setFallidos] = useState<CasoPrueba[]>([]);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    let cancelado = false;
    setLoading(true);
    getCasosPrueba(projectId)
      .then((casos) => { if (!cancelado) setFallidos(casos.filter((c) => c.estado === 'Fallido')); })
      .catch((err) => console.error('Error cargando casos de prueba fallidos:', err))
      .finally(() => { if (!cancelado) setLoading(false); });
    return () => { cancelado = true; };
  }, [projectId]);

  return { loading, fallidos };
}
